export default __webpack_public_path__ + "static/media/agco-logo.1b21d3f8.png";